import { render, staticRenderFns } from "./TItems.vue?vue&type=template&id=b7fefcaa&"
import script from "./TItems.vue?vue&type=script&lang=js&"
export * from "./TItems.vue?vue&type=script&lang=js&"
import style0 from "./TItems.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports